<template>
  <b-row>
    <b-col lg="3" md="4" sm="6" xl="2">
      <b-form-group
          :label="$t('user.dateOfGraduation')"
          class="required-group"
          label-for="user-dateOfGraduation"
      >
        <my-ab-date-picker
            v-model="dateOfGraduation"
            :auto-submit="true"
            :column="1"
            :locale="'fa,en'"
            :mode="'single'"
            :show="false"
            :type="'date'"
            clearable
            click-on="all"
        >
        </my-ab-date-picker>
      </b-form-group>
    </b-col>
    <b-col lg="3" md="4" sm="6" xl="2">
      <b-form-group
          :invalid-feedback="
                      invalidFeedbackFieldOfStudy
                        ? $t(`validation.${invalidFeedbackFieldOfStudy}`, {
                            field: $t('user.fieldOfStudy'),
                          })
                        : ''
                    "
          :label="$t('user.fieldOfStudy')"
          :state="v.fieldOfStudy.$dirty ? ((!v.fieldOfStudy.$invalid === false) ? false : null) : null"
          :class="{ 'required-group': !v.fieldOfStudy.required }"
          label-for="user-fieldOfStudy"
      >
        <b-form-input
            id="user-fieldOfStudy"
            v-model="fieldOfStudy"
            :state="v.fieldOfStudy.$dirty ? ((!v.fieldOfStudy.$invalid === false) ? false : null) : null"
            text-field="title"
            value-field="_id"
        />
      </b-form-group>
    </b-col>
    <b-col lg="3" md="4" sm="6" xl="2">
      <b-form-group
          :label="$t('user.educationalDegree')"
          label-for="user-educationalDegree"
      >
        <my-v-select
            :key="educationalDegree"
            id="user-educationalDegree"
            v-if="educationalDegreeTypes"
            :translate="false"
            v-model="educationalDegree"
            :concat-label="['text']"
            :reduce-field="['value']"
            :options="educationalDegreeTypes.length ? educationalDegreeTypes : []"
            :multiple="false"
            :searchable="true"
            :filterable="true"
        />

      </b-form-group>
    </b-col>


  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import {mapGetters} from 'vuex';
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
export default {
  components:{
    MyVSelect,
    MyAbDatePicker,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormInvalidFeedback},
  props:['v'],
  computed:{
    ...mapGetters({
      educationalDegreeTypes: "user/educationalDegreeTypes",
    }),
    dateOfGraduation: {
      set(dateOfGraduation) {
        this.$store.commit("user/SET_DATE_OF_GRADUATION", dateOfGraduation);
      },
      get() {
        return this.$store.getters["user/dateOfGraduation"];
      },
    },
    fieldOfStudy: {
      set(fieldOfStudy) {
        this.$store.commit("user/SET_FIELD_OF_STUDY", fieldOfStudy);
      },
      get() {
        return this.$store.getters["user/fieldOfStudy"];
      },
    },
    educationalDegree: {
      set(educationalDegree) {
        this.$store.commit("user/SET_EDUCATIONAL_DEGREE", educationalDegree);
      },
      get() {
        return this.$store.getters["user/educationalDegree"];
      },
    },
    // invalidFeedbackDateOfGraduation: {
    //   set(error) {
    //   },
    //   get() {
    //     var error = "";
    //     if (!this.v.dateOfGraduation.$dirty) return error;
    //     if (!this.v.dateOfGraduation.required) error = "required";
    //     return error;
    //   },
    // },
    invalidFeedbackFieldOfStudy: {
      set(error) {
      },
      get() {
        var error = "";
        if (!this.v.fieldOfStudy.$dirty) return error;
        if (!this.v.fieldOfStudy.required) error = "required";
        return error;
      },
    },
    // invalidFeedbackEducationalDegree: {
    //   set(error) {
    //   },
    //   get() {
    //     var error = "";
    //     if (!this.v.educationalDegree.$dirty) return error;
    //     if (!this.v.educationalDegree.required) error = "required";
    //     return error;
    //   },
    // },
  }
}
</script>